export const COMPANY_INFO = {
  name: "Tømrermester Søren Emil v/Jacob Heiselberg",
  owner: "Jacob Rokkjær Heiselberg",
  address: "Gl Landevej 24, Obbekær",
  city: "6760 Ribe",
  cvr: "45200779",
  phone: "+45 42 47 58 58",
  phoneRaw: "42475858",
  email: "jacob@tm-jacob.dk",
  mapsUrl: "https://maps.app.goo.gl/FC9x3CYmzHbkNeLs8",
  logoUrl: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/tomrer-logo.png",
  logoAlt: "Tømrermester Søren Emil v/Jacob Heiselberg Logo",
  areas: ["Ribe", "Esbjerg", "Bramming", "Skærbæk", "Gørding", "Vojens", "Gram", "Rødding"]
};

export const SOURCE_OPTIONS = [
  "Vælg her...",
  "Anbefalet af andre",
  "Google / søgemaskiner",
  "Annonce på nettet",
  "Annonce i avis",
  "På anden hjemmeside",
  "Facebook",
  "Andet reklamemateriale"
];

export const HOME_FAQS = [
  {
    question: "Hvilke opgaver kan en tømrermester hjælpe med?",
    answer: "Søren Emil udfører både tømrerarbejde og snedkerarbejde for private og erhverv. Opgaverne omfatter alt fra mindre reparationer, træterrasser og skure til nyt tag, udskiftning af døre og vinduer, køkken- og badeværelsesrenovering, tilbygninger samt hoved- og totalentreprise."
  },
  {
    question: "Hvordan vurderer man, om taget skal renoveres eller udskiftes?",
    answer: "Søren Emil gennemgår tagets belægning, undertag og konstruktion, før der anbefales en løsning. Afhængigt af tagets tilstand vurderes det, om en målrettet reparation, ny tagbelægning eller en komplet ny tagkonstruktion med forbedret isolering er den bedste vej."
  },
  {
    question: "Hvilke materialer kan bruges til et nyt tag?",
    answer: "Søren Emil arbejder blandt andet med tegl, beton, stål, eternit, tagpap og skifer. Valget til et nyt tag afstemmes efter husets arkitektur, taghældning, vægtbærende konstruktion og dit budget."
  },
  {
    question: "Hvad er fordelene ved udskiftning af døre og vinduer?",
    answer: "En udskiftning af døre og vinduer kan give boligen et nyt udtryk og reducere gener fra kulde og træk. Samtidig forbedres energieffektiviteten og indeklimaet, og boligen bliver lettere at vedligeholde."
  },
  {
    question: "Hvad kan indgå i en renovering af hus?",
    answer: "Hos Søren Emil kan en renovering af hus blandt andet omfatte køkkenrenovering, tagarbejde, nye vinduer og døre, badeværelsesfornyelse samt omfattende ombygninger og tilbygninger."
  },
  {
    question: "Hvordan skaber man overblik i et byggeprojekt med flere håndværksfag?",
    answer: "Ved hovedentreprise eller totalentreprise kan Søren Emil koordinere de relevante håndværksfag gennem faste lokale samarbejdspartnere. Det giver dig én tydelig kontaktperson og fuldt overblik fra skitse til færdigt resultat."
  },
  {
    question: "Hvad koster en tømreropgave?",
    answer: "Prisen afhænger af opgavens omfang, bygningens tilstand og de valgte materialer. Søren Emil tager udgangspunkt i en konkret gennemgang frem for standardpriser og udarbejder et gennemskueligt tilbud på din opgave."
  }
];

export const ROOF_FAQS = [
  {
    question: "Hvornår bør man vælge renovering af tag frem for udskiftning af tag?",
    answer: "Renovering af tag kan være relevant, når den bærende konstruktion fortsat er sund, og problemerne er afgrænsede til slidte tagsten, mindre utætheder eller udskiftning af enkelte elementer."
  },
  {
    question: "Hvilke tegn viser, at boligen har brug for et nyt tag?",
    answer: "Tegn på behov for et nyt tag kan være revnede eller løse tagsten og tagplader, fugt eller misfarvninger på loftet, slidt undertag eller et tag, der kræver hyppige og gentagne reparationer."
  },
  {
    question: "Hvordan foregår montering af nyt tag?",
    answer: "Montering af nyt tag begynder hos Søren Emil med en vurdering af bygningen, det eksisterende tag, hældning og bæreevne. Herefter udarbejdes et tilbud, og arbejdet udføres med fokus på undertag, isolering og præcis finish."
  },
  {
    question: "Hvilket materiale skal man vælge til et nyt tag?",
    answer: "Valget kan blandt andet stå mellem tegl, betontagsten, stål, eternit, skifer og tagpap. Det rigtige valg afhænger af husets stil, konstruktionens bæreevne og dine krav til holdbarhed og udseende."
  },
  {
    question: "Hvad påvirker prisen på et nyt tag?",
    answer: "Prisen på et nyt tag afhænger ikke kun af tagets areal. Tagtype, hældning, kviste, gennembrydninger, adgangsforhold, materialevalg samt behov for nyt undertag og konstruktionsændringer spiller ind."
  },
  {
    question: "Hvad kræver udskiftning af et asbest tag?",
    answer: "Et ældre eternittag kan indeholde asbest og må ikke håndteres som almindeligt byggeaffald. Pladerne må ikke knækkes eller bores i, og nedtagning skal planlægges og udføres efter gældende regler med korrekt emballering og bortskaffelse."
  }
];

export const WINDOWS_FAQS = [
  {
    question: "Hvornår giver udskiftning af døre og vinduer mening?",
    answer: "Udskiftning af døre og vinduer kan være relevant, når elementerne giver træk eller kuldenedfald, har råd eller revner, har punkterede ruder eller binder og ikke lukker tæt."
  },
  {
    question: "Kan gamle karme bruges til nye vinduer og døre?",
    answer: "Eksisterende karme kan i nogle tilfælde bevares, hvis de er i forsvarlig stand og passer til den valgte løsning, hvorved der kun monteres nye ruder eller dørplader."
  },
  {
    question: "Hvilke materialer kan man vælge til vinduer og døre?",
    answer: "Vinduer og døre kan blandt andet vælges i klassisk træ, vedligeholdelseslet træ/aluminium eller PVC/plast, alt efter husets stil og dine præferencer for vedligeholdelse."
  },
  {
    question: "Hvad er vigtigt ved montering af vinduer og døre?",
    answer: "Korrekt montering af vinduer og døre kræver præcise opmålinger, omhyggelig tilpasning, korrekt fastgørelse, tæt isolering og en pæn afslutning omkring karme og lysninger."
  },
  {
    question: "Hvad koster udskiftning af døre og vinduer?",
    answer: "Prisen afhænger blandt andet af antallet og målene på elementerne, materialevalget, glastypen (energiruder/termoruder), tilstanden omkring karmene og monteringsomfanget."
  },
  {
    question: "Hvilke typer døre og vinduer kan man få monteret?",
    answer: "Søren Emil monterer blandt andet dannebrogsvinduer, bondehusvinduer, vinduer med sprosser, panoramapartier, Velux ovenlysvinduer, facadedøre, terrassedøre og skydedøre."
  }
];

export const RENOVATION_FAQS = [
  {
    question: "Hvad kan indgå i en renovering af hus?",
    answer: "Hos Søren Emil kan renovering af hus omfatte alt fra afgrænsede tømreropgaver til større byggeprojekter såsom køkkenrenovering, badeværelsesopdatering, udskiftning af døre og vinduer samt tagrenovering."
  },
  {
    question: "Hvordan planlægges en renovering af hus fra start til slut?",
    answer: "Søren Emil begynder med en samtale om ønsker, behov og økonomisk ramme. Herefter vurderes huset og arbejdet afgrænses, materialer vælges, og der udarbejdes et konkret tilbud og en tidsplan for forløbet."
  },
  {
    question: "Hvornår er en total renovering den rigtige løsning?",
    answer: "En total renovering kan være relevant, når flere rum eller bygningsdele skal opdateres samtidig, f.eks. ved ændret planløsning, nyt køkken og bad eller samlet fornyelse af klimaskærmen."
  },
  {
    question: "Hvad omfatter renovering af køkken?",
    answer: "Ved renovering af køkken udfører Søren Emil tømrerarbejde og snedkerarbejde, der tilpasses rummets brug og stil, herunder opsætning af elementer, tilpasning af bordplader og koordinering med andre fag."
  },
  {
    question: "Hvad skal man være opmærksom på ved renovering af badeværelse?",
    answer: "Renovering af badeværelse kræver grundig planlægning, egnede vådrumsmaterialer og en korrekt rækkefølge mellem faggrupperne (tømrer, murer, VVS og elektriker)."
  },
  {
    question: "Kan nyt tag, vinduer og døre indgå i renoveringen?",
    answer: "Ja, Søren Emil udfører både nyt tag, tagrenovering samt udskiftning af vinduer og døre. Arbejdet kan med fordel samtænkes med den indvendige renovering."
  },
  {
    question: "Hvordan får man et konkret tilbud på renovering?",
    answer: "Et tilbud hos Søren Emil tager udgangspunkt i en indledende samtale og en faglig vurdering af boligen. Prisen afstemmes efter dine ønsker og projektets reelle omfang."
  }
];
